module.exports = {
    debug : function () {
        console.log("base to do something")
    },
    getIp() {
        // console.log(returnCitySN.cip);
        return returnCitySN.cip;
    }
}